export default __webpack_public_path__ + "static/media/Add.5acb89c1.svg";